import React from 'react';

import emeryturaBad from '@/assets/img/documents/case-card/emerytura-bad.jpg';
import emeryturaGood from '@/assets/img/documents/case-card/emerytura-good.jpg';
import instructionCorrect from '@/assets/img/documents/case-card/skd-correct.jpg';
import instructionWrong from '@/assets/img/documents/case-card/skd-wrong.jpg';
import dominik from '@/assets/img/dominik.jpg';
import LogoOc from '@/assets/logo-oc.svg?react';
import { CASE_CARD_PRODUCT, CASE_CARD_SITE, KASKA_CONSULTANT } from '@/consts';
import { CaseCardPageData } from '@/features/caseCard/content.types';

export const pageData: Record<string, CaseCardPageData> = {
  [CASE_CARD_PRODUCT.SKD]: {
    navbar: {
      title: 'Wgrywanie załączników',
      phone: '734 829 290',
    },
    chatMessage: {
      consultant: {
        ...KASKA_CONSULTANT,
        jobDescription: 'Specjalistka ds. sankcji kredytu darmowego',
      },
      description: (
        <>
          Przyspiesz analizę swojej sprawy, przesyłając:{' '}
          <ul className="list-disc pl-5">
            <li>umowę pożyczki (wszystkie strony),</li>
            <li>aktualny raport BIK w formacie PDF (cały dokument).</li>
          </ul>
        </>
      ),
    },
    closableCard: {
      text: "Dodaj dokumenty poniżej lub prześlij na maila <a href='mailto:sankcje@helpfind.pl'>sankcje@helpfind.pl</a>",
    },
    instruction: {
      title: 'Jak poprawnie dodać dokumenty?',
      correctImg: instructionCorrect,
      wrongImg: instructionWrong,
      steps: [
        'Załącz wszystkie strony umowy kredytowej i harmonogramu rat.',
        'Zadbaj, żeby zdjęcia dokumentów były czytelne i niepogięte.',
        'Upewnij się, że umowa kredytowa jest podpisana przez wszystkich kredytobiorców (wersja elektroniczna nie wymaga podpisu).',
      ],
    },
    button: {
      text: 'Wyślij',
    },
    dialog: {
      title: 'Dziękujemy za przesłanie załączników',
      info: 'Jeśli chcesz dodać dodatkowe dokumenty, które mogą przyspieszyć analizę, zrób to teraz. Pozwoli nam to szybciej i skuteczniej zająć się Twoją sprawą.',
      button: 'Załącz więcej dokumentów',
      secondaryButton: 'Zamknij',
    },
  },
  [CASE_CARD_PRODUCT.CARTEL]: {
    navbar: {
      title: 'Wgrywanie załączników',
      phone: '734 829 290',
    },
    chatMessage: {
      consultant: KASKA_CONSULTANT,
      description: (
        <>
          <strong>Przyśpiesz analizę sprawy nawet o 70%</strong> i wgraj jeden z
          dokumentów: fakturę zakupu lub sprzedaży, umowę leasingu lub kredytu,
          skan dowodu rejestracyjnego lub kopię umowy jeśli zlecono sprawę innej
          kancelarii.
        </>
      ),
    },
    button: {
      text: 'Wyślij',
    },
    dialog: {
      title: 'Dziękujemy za przesłanie załączników',
      info: 'Jeśli chcesz dodać dodatkowe dokumenty, które mogą przyspieszyć analizę, zrób to teraz. Pozwoli nam to szybciej i skuteczniej zająć się Twoją sprawą.',
      button: 'Załącz więcej dokumentów',
      secondaryButton: 'Zamknij',
    },
  },
  [CASE_CARD_PRODUCT.DEVELOPERS]: {
    navbar: {
      title: 'Wgrywanie załączników',
      phone: '734 827 600',
    },
    chatMessage: {
      description: (
        <>
          <p>
            <strong>Znacząco przyspiesz analizę swojej sprawy</strong> i wgraj
            poniższe dokumenty:
          </p>
          <ul className="list-disc pl-5">
            <li>umowa deweloperska wraz z załącznikami, </li>
            <li>projekty, rzuty oraz pomiary mieszkania, </li>
            <li>umowa przeniesienia własności z aneksami.</li>
          </ul>
        </>
      ),
    },
    button: {
      text: 'Wyślij',
    },
    dialog: {
      title: 'Dziękujemy za przesłanie załączników',
      info: 'Jeśli chcesz dodać dodatkowe dokumenty, które mogą przyspieszyć analizę, zrób to teraz. Pozwoli nam to szybciej i skuteczniej zająć się Twoją sprawą.',
      button: 'Załącz więcej dokumentów',
      secondaryButton: 'Zamknij',
    },
  },
  [CASE_CARD_PRODUCT.PARABANKS]: {
    navbar: {
      title: 'Wgrywanie załączników',
      phone: '538 234 800',
    },
    chatMessage: {
      consultant: KASKA_CONSULTANT,
      description: (
        <>
          <p>Przyspiesz analizę swojej sprawy, przesyłając:</p>
          <ul className="list-disc pl-5">
            <li>umowę pożyczki (wszystkie strony),</li>
            <li>aktualny raport BIK w formacie PDF (cały dokument).</li>
          </ul>
        </>
      ),
    },
    instruction: {
      title: 'Jak poprawnie dodać dokumenty?',
      correctImg: instructionCorrect,
      wrongImg: instructionWrong,
      steps: [
        'Załącz wszystkie strony umowy pożyczki i pakietów lub usług dodatkowych.',
        'Zadbaj, żeby zdjęcia dokumentów były czytelne i niepogięte.',
      ],
    },
    button: {
      text: 'Wyślij',
    },
    dialog: {
      title: 'Dziękujemy za przesłanie załączników',
      info: 'Jeśli chcesz dodać dodatkowe dokumenty, które mogą przyspieszyć analizę, zrób to teraz. Pozwoli nam to szybciej i skuteczniej zająć się Twoją sprawą.',
      button: 'Załącz więcej dokumentów',
      secondaryButton: 'Zamknij',
    },
  },
  [CASE_CARD_PRODUCT.VEHICLE_DAMAGE]: {
    navbar: {
      title: 'Wgrywanie załączników',
      phone: '538 233 974',
    },
    chatMessage: {
      consultant: KASKA_CONSULTANT,
      description: (
        <>
          Załącz kosztorys, decyzję ubezpieczyciela, zdjęcia uszkodzeń, skan lub
          czytelne zdjęcie dowodu rejestracyjnego oraz notatkę policyjną lub
          oświadczenie sprawcy kolizji. Jeśli nie masz któregoś z wymienionych
          dokumentów, możesz dosłać go później.
        </>
      ),
    },
    button: {
      text: 'Wyślij',
    },
    dialog: {
      title: 'Dziękujemy za przesłanie załączników',
      info: 'Jeśli chcesz dodać dodatkowe dokumenty, które mogą przyspieszyć analizę, zrób to teraz. Pozwoli nam to szybciej i skuteczniej zająć się Twoją sprawą.',
      button: 'Załącz więcej dokumentów',
      secondaryButton: 'Zamknij',
    },
  },
  [CASE_CARD_PRODUCT.HOUSE_HOLD]: {
    navbar: {
      title: 'Wgrywanie załączników',
      phone: '718 898 090',
    },
    chatMessage: {
      consultant: KASKA_CONSULTANT,
      description: (
        <>
          <strong>Przyspiesz analizę Twojej sprawy o 70%</strong>. Załącz
          decyzję ubezpieczyciela i pełne akta szkody (jeśli je posiadasz).
          Pomocne w analizie będą także zdjęcia uszkodzeń oraz skan polisy
          ubezpieczeniowej, jeśli szkoda likwidowana jest z polisy własnej.
        </>
      ),
    },
    button: {
      text: 'Wyślij',
    },
    dialog: {
      title: 'Dziękujemy za przesłanie załączników',
      info: 'Jeśli chcesz dodać dodatkowe dokumenty, które mogą przyspieszyć analizę, zrób to teraz. Pozwoli nam to szybciej i skuteczniej zająć się Twoją sprawą.',
      button: 'Załącz więcej dokumentów',
      secondaryButton: 'Zamknij',
    },
  },
  [CASE_CARD_PRODUCT.RETIREMENT]: {
    navbar: {
      title: 'Wgrywanie załączników',
      phone: '538 234 999',
    },
    chatMessage: {
      description: (
        <>
          <p>Jakie dokumenty są potrzebne do analizy?</p>
          <ul className="list-disc pl-5">
            <li>Decyzja o przyznaniu emerytury wcześniejszej</li>
            <li>Decyzja o przyznaniu emerytury powszechnej </li>
          </ul>
          <p className="pt-2">
            Jeśli nie masz tych dokumentów, złóż wniosek do ZUS o ich wydanie.
            Potrzebujesz wsparcia? Skontaktuj się z nami – chętnie pomożemy.
          </p>
        </>
      ),
    },
    button: {
      text: 'Wyślij',
    },
    dialog: {
      title: 'Dziękujemy za przesłanie załączników',
      info: 'Jeśli chcesz dodać dodatkowe dokumenty, które mogą przyspieszyć analizę, zrób to teraz. Pozwoli nam to szybciej i skuteczniej zająć się Twoją sprawą.',
      button: 'Załącz więcej dokumentów',
      secondaryButton: 'Zamknij',
    },
    instruction: {
      title: 'Jak poprawnie dodać dokumenty?',
      steps: [
        'Załącz wszystkie strony decyzji o przyznaniu emerytury.',
        'Zadbaj, żeby zdjęcia dokumentów były czytelne i niepogięte.',
      ],
      correctImg: emeryturaGood,
      wrongImg: emeryturaBad,
    },
  },
  [CASE_CARD_PRODUCT.DRYING]: {
    navbar: {
      title: 'Wgrywanie załączników',
      phone: '616 350 050',
    },
    chatMessage: {
      consultant: {
        name: 'Dominik Dopierała',
        jobDescription: 'Lider Deepdry',
        image: dominik,
      },
      description: (
        <>
          <p>Chcemy znacząco przyspieszyć analizę Twojej sprawy. Prześlij: </p>
          <ul className="list-disc pl-5">
            <li>decyzję oraz kosztorys ubezpieczyciela, </li>
            <li>polisę ubezpieczeniową, </li>
            <li>zdjęcia uszkodzeń.</li>
          </ul>
        </>
      ),
    },
    button: {
      text: 'Wyślij',
    },
    dialog: {
      title: 'Dziękujemy za przesłanie załączników',
      info: 'Jeśli chcesz dodać dodatkowe dokumenty, które mogą przyspieszyć analizę, zrób to teraz. Pozwoli nam to szybciej i skuteczniej zająć się Twoją sprawą.',
      button: 'Załącz więcej dokumentów',
      secondaryButton: 'Zamknij',
    },
  },
  [CASE_CARD_PRODUCT.WIBOR]: {
    navbar: {
      title: null,
      phone: null,
    },
    chatMessage: {
      consultant: KASKA_CONSULTANT,
      description: (
        <>
          <p>Przyspiesz analizę swojej sprawy, przesyłając:</p>
          <ul className="list-disc pl-5">
            <li>wszystkie strony umowy kredytowej,</li>
            <li>ewentualne aneksy do umowy,</li>
            <li>formularz informacyjny,</li>
            <li>oświadczenie o ryzyku,</li>
            <li>
              historię spłat kredytu (z rozbiciem na kapitał i odsetki), jeśli
              posiadasz taki dokument. W przypadku jego braku, po analizie
              wstępnej pomożemy Ci go uzyskać.
            </li>
          </ul>
        </>
      ),
    },
    button: {
      text: 'Wyślij',
    },
    dialog: {
      title: 'Dziękujemy za przesłanie załączników',
      info: 'Jeśli chcesz dodać dodatkowe dokumenty, które mogą przyspieszyć analizę, zrób to teraz. Pozwoli nam to szybciej i skuteczniej zająć się Twoją sprawą.',
      button: 'Załącz więcej dokumentów',
      secondaryButton: 'Zamknij',
    },
  },
  [CASE_CARD_PRODUCT.DEFAULT]: {
    navbar: {
      title: 'Wgrywanie załączników',
      phone: '616 350 050',
    },
    chatMessage: {
      consultant: KASKA_CONSULTANT,
      description: (
        <>
          <strong>
            Chcemy znacząco przyspieszyć analizę Twojej sprawy, nawet o 70%!
          </strong>
          Załącz już teraz całą dokumentację Twojej sprawy (najlepiej skany lub
          wyraźne zdjęcia). Im więcej informacji otrzymamy, tym bardziej
          precyzyjna będzie nasza analiza. Nie potrzebujemy Twoich danych
          osobowych, możesz je zakryć.
        </>
      ),
    },
    button: {
      text: 'Wyślij',
    },
    dialog: {
      title: 'Dziękujemy za przesłanie załączników',
      info: 'Jeśli chcesz dodać dodatkowe dokumenty, które mogą przyspieszyć analizę, zrób to teraz. Pozwoli nam to szybciej i skuteczniej zająć się Twoją sprawą.',
      button: 'Załącz więcej dokumentów',
      secondaryButton: 'Zamknij',
    },
  },
  [CASE_CARD_PRODUCT.TRANSMISSION_EASEMENT]: {
    navbar: {
      title: 'Wgrywanie załączników',
      phone: '538 233 966',
    },
    detailsDialog: true,
    chatMessage: {
      consultant: KASKA_CONSULTANT,
      description: (
        <>
          <p>Lista wymaganych dokumentów:</p>
          <ul className="list-disc pl-5">
            <li>Skany lub wyraźne zdjęcia aktu własności</li>
            <li>Zdjęcia infrastruktury na Twojej działce</li>
            <li>
              Korespondencja z przedsiębiorstwem przesyłowym (jeśli była
              prowadzona)
            </li>
            <li>
              Dodatkowe dokumenty urzędowe, np. decyzje administracyjne
              zezwalające na posadowienie tych urządzeń na Twojej działce
            </li>
          </ul>
        </>
      ),
    },
    button: {
      text: 'Wyślij',
    },
    dialog: {
      title: 'Dziękujemy za przesłanie załączników',
      info: 'Jeśli chcesz dodać dodatkowe dokumenty, które mogą przyspieszyć analizę, zrób to teraz. Pozwoli nam to szybciej i skuteczniej zająć się Twoją sprawą.',
      button: 'Załącz więcej dokumentów',
      secondaryButton: 'Zamknij',
    },
  },
  [CASE_CARD_PRODUCT.SALARY_EQUALIZATION]: {
    navbar: {
      title: 'Wgrywanie załączników',
      phone: '734 825 525',
    },
    chatMessage: {
      consultant: KASKA_CONSULTANT,
      description: (
        <>
          <p>Prosimy o przesłanie skanów:</p>
          <ul className="list-disc pl-5">
            <li>regulamin wynagradzania,</li>
            <li>zakresy obowiązków obu grup pielęgniarek,</li>
            <li>wykaz wszystkich pielęgniarek objętych porównaniem,</li>
            <li>informacje o specjalizacjach i kwalifikacjach,</li>
            <li>grafiki pracy i harmonogramy,</li>
            <li>paski płacowe za ostatnie 3 lata,</li>
            <li>opisy stanowisk pracy.</li>
          </ul>
        </>
      ),
    },
    button: {
      text: 'Wyślij',
    },
    dialog: {
      title: 'Dziękujemy za przesłanie załączników',
      info: 'Jeśli chcesz dodać dodatkowe dokumenty, które mogą przyspieszyć analizę, zrób to teraz. Pozwoli nam to szybciej i skuteczniej zająć się Twoją sprawą.',
      button: 'Załącz więcej dokumentów',
      secondaryButton: 'Zamknij',
    },
    instruction: {
      title: 'Jak poprawnie dodać dokumenty?',
      steps: [
        'Załącz wszystkie strony wymienionych dokumentów.',
        'Zadbaj, żeby zdjęcia lub skany dokumentów były czytelne i niepogięte.',
      ],
    },
  },
  [CASE_CARD_PRODUCT.POLISOLOKATY]: {
    navbar: {
      title: 'Wgrywanie załączników',
      phone: '717 443 939',
    },
    chatMessage: {
      consultant: KASKA_CONSULTANT,
      description: (
        <>
          <p>Prosimy o przesłanie skanów:</p>
          <ul className="list-disc pl-5">
            <li>wniosku o zawarcie polisy;</li>
            <li>certyfikatu polisy;</li>
            <li>rozliczenia polisy na dzień rozwiązania umowy;</li>
            <li>
              zestawienia wpłaconych składek i pobranych opłat podczas trwania
              polisy;
            </li>
            <li>OWU, REGULAMINU UFK, Tabeli Limitów i Opłat.</li>
          </ul>
          <p>
            Wszystkie wyżej wymienione dokumenty uzyskasz drogą mailową od
            towarzystwa ubezpieczeń po podaniu swojego numeru PESEL.
          </p>
        </>
      ),
    },
    button: {
      text: 'Prześlij pliki',
    },
    dialog: {
      title: 'Dziękujemy za przesłanie załączników',
      info: 'Jeśli chcesz dodać dodatkowe dokumenty, które mogą przyspieszyć analizę, zrób to teraz. Pozwoli nam to szybciej i skuteczniej zająć się Twoją sprawą.',
      button: 'Załącz więcej dokumentów',
      secondaryButton: 'Zamknij',
    },
  },
};

const zgloszenieSzkodyOcNieruchomosciPageData: CaseCardPageData = {
  navbar: {
    title: 'Wgrywanie załączników',
    phone: '+48 222 287 871',
    compactPhoneButton: true,
    phoneColor: 'oxfordBlue' as const,
    logo: <LogoOc className="h-8 w-[196px] lg:h-10 lg:w-[245px]" />,
  },
  chatMessage: {
    consultant: KASKA_CONSULTANT,
    description: (
      <>
        <p>
          Chcemy znacząco przyspieszyć analizę i zgłoszenie Twojej szkody.
          Prześlij:
        </p>
        <ul className="list-disc pl-5">
          <li>zdjęcia uszkodzeń,</li>
          <li>zdjęcia lub skan własnej polisy – w przypadku szkody z AC.</li>
        </ul>
      </>
    ),
  },
  btnDescription: 'Akceptowane pliki: .jpg, .pdf, .jfif oraz .png',
  button: {
    text: 'Wyślij',
    color: 'green' as const,
  },
  dialog: {
    title: 'Dziękujemy za przesłanie załączników',
    info: 'Jeśli chcesz dodać dodatkowe dokumenty, które mogą przyspieszyć analizę, zrób to teraz. Pozwoli nam to szybciej i skuteczniej zająć się Twoją sprawą.',
    button: 'Załącz więcej dokumentów',
    secondaryButton: 'Zamknij',
  },
};

const zgloszenieSzkodyOcPojazduPageData: CaseCardPageData = {
  navbar: {
    title: 'Wgrywanie załączników',
    phone: '+48 222 287 871',
    compactPhoneButton: true,
    phoneColor: 'oxfordBlue' as const,
    logo: <LogoOc className="h-8 w-[196px] lg:h-10 lg:w-[245px]" />,
  },
  chatMessage: {
    consultant: KASKA_CONSULTANT,
    description: (
      <>
        <p>
          Chcemy znacząco przyspieszyć analizę i zgłoszenie Twojej szkody.
          Prześlij:
        </p>
        <ul className="list-disc pl-5">
          <li>dowód rejestracyjny,</li>
          <li>zdjęcia uszkodzeń,</li>
          <li>zdjęcia lub skan własnej polisy – w przypadku szkody z AC,</li>
          <li>
            oświadczenie sprawcy kolizji lub notatka policyjna – w przypadku
            szkody z OC.
          </li>
        </ul>
      </>
    ),
  },
  btnDescription: 'Akceptowane pliki: .jpg, .pdf, .jfif oraz .png',
  button: {
    text: 'Wyślij',
    color: 'green' as const,
  },
  dialog: {
    title: 'Dziękujemy za przesłanie załączników',
    info: 'Jeśli chcesz dodać dodatkowe dokumenty, które mogą przyspieszyć analizę, zrób to teraz. Pozwoli nam to szybciej i skuteczniej zająć się Twoją sprawą.',
    button: 'Załącz więcej dokumentów',
    secondaryButton: 'Zamknij',
  },
};

// Content for site + product combinations that override the default,
// product-only `pageData` lookup. Checked before falling back to `pageData`.
const pageDataBySite: Partial<
  Record<string, Partial<Record<string, CaseCardPageData>>>
> = {
  [CASE_CARD_SITE.ZGLOSZENIE_SZKODY_OC]: {
    [CASE_CARD_PRODUCT.HOUSE_HOLD]: zgloszenieSzkodyOcNieruchomosciPageData,
    [CASE_CARD_PRODUCT.HOUSE_HOLD_97]: zgloszenieSzkodyOcNieruchomosciPageData,
    [CASE_CARD_PRODUCT.VEHICLE_DAMAGE]: zgloszenieSzkodyOcPojazduPageData,
    [CASE_CARD_PRODUCT.VEHICLE_DAMAGE_CASHLESS]:
      zgloszenieSzkodyOcPojazduPageData,
  },
};

export const getCaseCardContent = (
  productId?: number,
  site?: string
): CaseCardPageData => {
  const product = productId || CASE_CARD_PRODUCT.SKD;

  return (
    (site && pageDataBySite[site]?.[product]) ||
    pageData[product] ||
    pageData[CASE_CARD_PRODUCT.DEFAULT]
  );
};
